import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col gap-0.5 absolute bottom-1 right-1 z-20"
}
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-1 rounded-md py-1 px-2 bg-gray-600 text-white"
}
const _hoisted_5 = {
  key: 0,
  class: "text-[10px]"
}
const _hoisted_6 = {
  key: 1,
  class: "flex items-center gap-1 rounded-md py-1 px-2 bg-gray-600 text-white"
}
const _hoisted_7 = {
  key: 0,
  class: "text-[10px]"
}
const _hoisted_8 = {
  key: 1,
  class: "flex items-center gap-1 rounded-md py-1 px-2 bg-gray-600 text-white absolute bottom-1 left-1 z-20"
}
const _hoisted_9 = { class: "text-[10px]" }
const _hoisted_10 = {
  key: 2,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute left-0.5 top-0.5 z-20"
}
const _hoisted_11 = {
  key: 0,
  class: "text-white -mt-2 mb-2"
}

import { ref } from 'vue';
import {
	PictureFilled,
	PlayCircleFilled,
	StarFilled,
	VideoCameraFilled
} from '@ant-design/icons-vue';
import ImageCard from '@/components/shared/ImageCard.vue';
import { File, Document } from '@/model/document';
import { DocumentViewMode, ActionMode } from '@/model/universal';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnlyfansCard',
  props: {
    file: {},
    viewMode: {},
    actionMode: {},
    total: {},
    current: {},
    onlyfan: {},
    isFavorite: { type: Boolean },
    stackCard: {}
  },
  emits: ["click"],
  setup(__props: any) {

const isLoading = ref(true);
const isError = ref(false);
const imagePlaceholder = ref(
	'https://www.signfix.com.au/wp-content/uploads/2017/09/placeholder-600x400.png'
);





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ImageCard, {
      viewMode: _ctx.viewMode,
      isLoading: isLoading.value,
      link: `/onlyfans/${_ctx.onlyfan.metadata.metadataID}/${_ctx.onlyfan.documentUUID}`,
      clickable: _ctx.actionMode === _unref(ActionMode).View && !isError.value && !isLoading.value
    }, {
      default: _withCtx(() => [
        (!isError.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.file.thumbnailURL,
              alt: "",
              loading: "lazy",
              referrerPolicy: "no-referrer",
              class: _normalizeClass(
				(isLoading.value ? 'w-0 h-0 ' : '') +
				'object-cover rounded-md shadow-xl drop-shadow-lg ' +
				(_ctx.viewMode !== _unref(DocumentViewMode).List
					? 'absolute top-0 right-0 z-20 w-full h-full'
					: 'max-w-2xl w-full')
			),
              onLoad: _cache[0] || (_cache[0] = 
				() => {
					(isLoading.value = false), (isError.value = false);
				}
			),
              onError: _cache[1] || (_cache[1] = 
				() => {
					(isLoading.value = false), (isError.value = true);
				}
			),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click', _ctx.onlyfan, _ctx.file)))
            }, null, 42, _hoisted_1))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: imagePlaceholder.value,
              alt: "",
              loading: "lazy",
              referrerPolicy: "no-referrer",
              class: _normalizeClass(
				(isLoading.value ? 'w-0 h-0 ' : '') +
				'object-cover rounded-md shadow-xl drop-shadow-lg ' +
				(_ctx.viewMode !== _unref(DocumentViewMode).List
					? 'absolute top-0 right-0 z-20 w-full h-full'
					: 'max-w-2xl w-full')
			)
            }, null, 10, _hoisted_2)),
        (_ctx.file.mimeType.startsWith('video/') && !isLoading.value)
          ? (_openBlock(), _createBlock(_unref(PlayCircleFilled), {
              key: 2,
              class: _normalizeClass(
				'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-30 text-black opacity-75 ' +
				(_ctx.viewMode === _unref(DocumentViewMode).List ? 'text-8xl' : 'text-4xl')
			)
            }, null, 8, ["class"]))
          : _createCommentVNode("", true),
        (!isError.value && !isLoading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.viewMode !== _unref(DocumentViewMode).List)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (
						_ctx.stackCard.image &&
						(_ctx.viewMode === _unref(DocumentViewMode).Stack || _ctx.file.mimeType.startsWith('image/'))
					)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_unref(PictureFilled), { style: { fontSize: '10px' } }),
                          (_ctx.viewMode === _unref(DocumentViewMode).Stack)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.stackCard.image), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
						_ctx.stackCard.video &&
						(_ctx.viewMode === _unref(DocumentViewMode).Stack || _ctx.file.mimeType.startsWith('video/'))
					)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(VideoCameraFilled), { style: { fontSize: '10px' } }),
                          (_ctx.viewMode === _unref(DocumentViewMode).Stack)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.stackCard.video), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.viewMode !== _unref(DocumentViewMode).List && _ctx.file.mimeType.startsWith('video/'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.file.duration && _ctx.file.duration.substring(0, 2) === '00'
						? _ctx.file.duration.substring(3)
						: _ctx.file.duration), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isFavorite)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_unref(StarFilled))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["viewMode", "isLoading", "link", "clickable"]),
    (_ctx.viewMode === _unref(DocumentViewMode).List)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.current) + " / " + _toDisplayString(_ctx.total), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})